<template>
    <div>
        <ToastNotification />
        <OfflineBanner />
        <InstallPrompt />
        <div v-if="authenticated === true" :class="mainWrapperClass">
            <div>
                <Header :sidebarTrigger="sidebarTrigger" :isDesktopSidebarCollapsed="!isMobile && desktopSidebarClosed" @open-user-manual="openUserManual" />
            </div>
            <Sidebar :role="role" :isOpen="mobileMenuOpen" :isDesktopClosed="desktopSidebarClosed" @close="closeSidebar"/>
            <div :class="pageWrapperClass">
                <router-view></router-view>
            </div>
            <nav class="mobile-bottom-nav" v-if="isMobile">
                <router-link to="/dashboard" class="nav-item" @click="closeSidebar">
                    <span class="material-symbols-outlined">dashboard</span>
                    <span>Dashboard</span>
                </router-link>
                <router-link to="/clients" class="nav-item" @click="closeSidebar">
                    <span class="material-symbols-outlined">group</span>
                    <span>Clients</span>
                </router-link>
                <router-link to="/events" class="nav-item" @click="closeSidebar">
                    <span class="material-symbols-outlined">event</span>
                    <span>Events</span>
                </router-link>
                <router-link to="/billings" class="nav-item" @click="closeSidebar">
                    <span class="material-symbols-outlined">payments</span>
                    <span>Billings</span>
                </router-link>
                <router-link to="/calendar" class="nav-item" @click="closeSidebar">
                    <span class="material-symbols-outlined">calendar_month</span>
                    <span>Calendar</span>
                </router-link>
            </nav>
            <FloatingChatButton v-if="authenticated" />
            <ChatPanel v-if="authenticated" />
            <UserManualOverlay
                v-if="userManualOpen"
                :visible="userManualOpen"
                @close="userManualOpen = false"
            />
        </div>
        <div v-else-if="!isMobile" class="main-wrapper">
            <router-view></router-view>
            <FloatingChatButton v-if="authenticated" />
            <ChatPanel v-if="authenticated" />
        </div>
        <div v-else-if="isMobile && !$route.meta.requireLogin" class="main-wrapper">
            <router-view></router-view>
        </div>
        <div tabindex="-1" ref="errorModal"
            class="fixed left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden md:inset-0 h-full">
            <div class="relative max-w-[95em] h-auto overflow-auto bg-white rounded-lg p-4">
                <div class="relative flex flex-col justify-center items-center text-center text-xl">
                    <h1>
                        Your email is still not verified. <br/>
                        Check your email for steps to verify your email.
                    </h1>
                    <hr class="my-4 w-full" />
                    <button class="btn btn-primary" @click="close">
                        Okay
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from './layouts/Header.vue'
import Sidebar from './layouts/Sidebar.vue'
import ToastNotification from './components/ToastNotification.vue'
import MobileBlocker from './components/MobileBlocker.vue'
import ChatPanel from './components/chat/ChatPanel.vue'
import FloatingChatButton from './components/chat/FloatingChatButton.vue'
import UserManualOverlay from './components/UserManualOverlay.vue'
import OfflineBanner from './pwa/OfflineBanner.vue'
import InstallPrompt from './pwa/InstallPrompt.vue'
import { Modal } from 'flowbite';
import { ROLES } from './constants/roles';
export default {
    components: {
        Header,
        Sidebar,
        ToastNotification,
        MobileBlocker,
        ChatPanel,
        FloatingChatButton,
        UserManualOverlay,
        OfflineBanner,
        InstallPrompt,
    },
    created() {
        this.checkAuth()
    },
    mounted() {
        this.modal = new Modal(this.$refs.errorModal, {closable: false})
        this.updateViewportHeight()
        this.checkMobile()
        window.addEventListener('resize', this.checkMobile)
        window.addEventListener('resize', this.updateViewportHeight)
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.checkMobile)
        window.removeEventListener('resize', this.updateViewportHeight)
    },
    watch: {
        $route(from, to) {
            this.checkAuth()
        }
    },
    data() {
        return {
            pageClass: "page-wrapper",
            pageSidebar: "sidebar",
            authenticated: false,
            modal: null,
            role: 0,
            sidebarOpen: false,
            mobileMenuOpen: false,
            desktopSidebarClosed: false,
            isMobile: false,
            userManualOpen: false,
        }
    },
    computed: {
        mainWrapperClass() {
            return {
                'main-wrapper': true,
                'sidebar-collapsed': !this.isMobile && this.desktopSidebarClosed
            }
        },
        pageWrapperClass() {
            if (!this.isMobile && this.desktopSidebarClosed) {
                return 'page-wrapper sidebar-expanded'
            }
            return 'page-wrapper'
        }
    },
    methods: {
        updateViewportHeight() {
            const vh = window.innerHeight * 0.01
            document.documentElement.style.setProperty('--app-vh', `${vh}px`)
        },
        checkMobile() {
            const wasMobile = this.isMobile
            this.isMobile = window.innerWidth < 768
            if (wasMobile && !this.isMobile) {
                this.mobileMenuOpen = false
            }
        },
        checkAuth() {
            if (this.$store.state.isAuthenticated) {
                axios.defaults.headers.common['Authorization'] = "Bearer " + this.$store.state.token
                axios.get('/api/get_token')
                .then((response) => {
                    const isAdmin = response.data.isAdmin
                    const isSales = response.data.isSales
                    const isAccounting = response.data.isAccounting
                    let role = 0
                    if (isAdmin) role = ROLES.ADMIN
                    else if (isSales) role = ROLES.SALES
                    else if (isAccounting) role = ROLES.ACCOUNTING
                    this.role = role
                    localStorage.setItem('role', role)
                    localStorage.setItem('id', response.data.id)
                })
                .catch((error)=>{
                    console.log(error)
                    if(error.response.data.message === "Your email address is not verified."){
                        this.pageClass = "page-wrapper-no-sidebar"
                        this.pageSidebar = "sidebar-closed"
                        this.modal.show()
                    }
                })
                this.authenticated = true
            }
            else {
                this.authenticated = false
            }
        },
        close(){
            this.modal.hide()
            axios.defaults.headers.common['Authorization'] = ""
            localStorage.removeItem("vuex")
            this.$store.commit('removeToken')
            this.$router.push({ path: "/" });
        },
        sidebarTrigger() {
            if (this.isMobile) {
                // Mobile: Toggle sidebar slide-in
                this.mobileMenuOpen = !this.mobileMenuOpen
            } else {
                // Desktop: Toggle sidebar visibility
                this.desktopSidebarClosed = !this.desktopSidebarClosed
            }
        },
        closeSidebar() {
            // Close mobile menu when overlay clicked
            this.mobileMenuOpen = false
        },
        openUserManual() {
            this.userManualOpen = true
        }
    }
}
</script>

<style scoped>
/* App layout specific styles */
.main-wrapper {
    min-height: 100vh;
    background: var(--color-bg-primary);
}

/* Mobile overlay for sidebar */
.mobile-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1003;
    cursor: pointer;
}

/* Content area padding */
.page-wrapper,
.page-wrapper-no-sidebar {
    box-sizing: border-box;
}

/* Ensure proper content flow */
.router-view-container {
    width: 100%;
}
</style>
